export const RELOAD_TIMESTAMP_KEY = "chunkReloadedAt";

export const RELOAD_COOLDOWN_MS = 10000;

// Message shapes webpack (build) and Vite (local) use when a lazily imported route
// chunk fails to arrive.
export const CHUNK_LOAD_ERROR_PATTERN =
  /loading chunk|loading css chunk|dynamically imported module/i;
